/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M6.
 * Account-scoped client for the Eva scenarios (specialist sub-agents) API.
 */
/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class EvaScenariosAPI extends ApiClient {
  constructor() {
    super('eva/scenarios', { accountScoped: true });
  }

  getByAssistant(assistantId) {
    return axios.get(this.url, { params: { eva_assistant_id: assistantId } });
  }
}

export default new EvaScenariosAPI();
